import { InputLabel, MenuItem, Select } from "@material-ui/core";
import { Countries, CountryNames } from "../../data";
import React from "react";
export default (function (props) {
    var countryFilter = function (country) {
        if (!props.enterprises) {
            return true;
        }
        return !!props.enterprises.find(function (e) { return e.countries.includes(country); });
    };
    var options = (props.countries || Countries).filter(countryFilter).map(function (c) { return (React.createElement(MenuItem, { value: c, key: c }, CountryNames[c])); });
    return (React.createElement("div", { className: "col s12 m6" },
        React.createElement(InputLabel, { id: "country" }, "Country"),
        React.createElement(Select, { onChange: function (e) { return props.onChange && props.onChange(e); }, placeholder: "Country", className: "select", name: "country", multiple: props.multiple, value: props.value, disabled: props.disabled || props.readonly, readOnly: props.readonly }, options)));
});



//////////////////
// WEBPACK FOOTER
// ./src/components/common/CountrySelect.tsx
// module id = 84
// module chunks = 0